import AdvertiseSection from "./AdvertiseSection";
import TimerElement from "./TimerElement";
import useUploadComplete from "../hooks/useUploadComplete";
import { useMail } from "contexts/mailContext/mailContext";
import { useContent } from "contexts/contentContext/contentContext";
import { useRef, useState } from "react";
import useOnClickOutside from "hooks/useOnClickOutside";
import CopyInput from "components/Reusable/ShareInput/CopyInput";
import ShareLinkElement from "./ShareLinkElement";
import UploadedFilesInfo from "./UploadedFilesInfo";

export interface AdsData {
  NotificationTitle: string;
  NotificationText: string;
  NotificationImage: string;
  NotificationMobileImage: string;
  NotificationLinkUrl: string;
  ButtonText: string;
}

interface UploadCompleteBodyI {
  handleShareClick: () => void;
  adsData: AdsData | null;
  loading: boolean;
}

const UploadCompleteBody = ({
  handleShareClick,
  adsData,
  loading,
}: UploadCompleteBodyI) => {
  const { getHtmlByKey } = useContent();
  const { getMailMetaData } = useMail();
  const { galleryMailLink } = useUploadComplete();

  const filesListRef = useRef<HTMLDivElement>(null);

  const [showFiles, setShowFiles] = useState(false);

  useOnClickOutside(filesListRef, () => setShowFiles(false));

  const recipientsList = getMailMetaData().RecipientsList || [];

  return (
    <div className="upload-complete-sidebar-body">
      <h3 className="upload-complete-sidebar-title">
        {getHtmlByKey("files-sent-successfully")}
      </h3>
      <CopyInput mailLink={galleryMailLink} />
      <div className="upload-complete-sidebar-body-row-wrap">
        <ShareLinkElement
          recipientsList={recipientsList}
          handleShareClick={handleShareClick}
        />
        <UploadedFilesInfo
          showFiles={showFiles}
          setShowFiles={setShowFiles}
          recipientsList={recipientsList}
          handleShareClick={handleShareClick}
          ref={filesListRef}
        />
        <TimerElement />
      </div>

      <AdvertiseSection adsData={adsData} loading={loading} />
    </div>
  );
};

export default UploadCompleteBody;
